import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const GithubBranchIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "GithubBranch",
    children: /*#__PURE__*/_jsx("path", {
      d: "M27.62 4.72c-.33-.76-.86-1.41-1.53-1.89s-1.46-.76-2.29-.82c-.82-.06-1.65.11-2.38.49a4.51 4.51 0 0 0-2.44 4c0 .93.29 1.84.83 2.6s1.3 1.33 2.17 1.65v1.26c0 .53-.21 1.04-.59 1.41-.38.38-.88.59-1.41.59h-7.99c-.69 0-1.37.14-2 .42v-3.67c1-.35 1.84-1.05 2.38-1.97s.73-1.99.55-3.04-.72-2-1.53-2.68-1.84-1.06-2.9-1.06-2.09.38-2.9 1.06S4.23 4.7 4.06 5.75s.02 2.12.55 3.04c.54.92 1.38 1.61 2.38 1.97v10.5c-1 .35-1.85 1.05-2.38 1.97-.54.92-.73 1.99-.55 3.04s.72 2 1.54 2.68 1.84 1.06 2.9 1.06 2.09-.38 2.9-1.06 1.36-1.63 1.54-2.68-.02-2.12-.55-3.04a4.53 4.53 0 0 0-2.38-1.97V19c0-.53.21-1.04.59-1.41.38-.38.88-.59 1.41-.59H20c1.33 0 2.6-.53 3.54-1.46C24.48 14.6 25 13.33 25 12v-1.26a4.504 4.504 0 0 0 2.63-6.04ZM9.56 26.55a1.499 1.499 0 1 1-2.12-2.12 1.499 1.499 0 1 1 2.12 2.12m0-18.99a1.499 1.499 0 1 1-2.12-2.12 1.499 1.499 0 1 1 2.12 2.12m14.99 0a1.499 1.499 0 1 1-2.12-2.12 1.499 1.499 0 1 1 2.12 2.12"
    })
  }));
};